import { apiRoutes } from "@constants/api-routes";
import { AppliedProfileTypes } from "@enums/applied-profile-types";
import { RequestTypes } from "@enums/request-types";
import { QueryParameter } from "@idw-types/common";
import { AppliedProfile } from "@idw-types/data/applied-profile/applied-profile";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { getQueryParamValueArray } from "@utils/string-util";

type GetWorkflowAppliedProfileRequestResponse = {
    axnAppliedProfiles: Array<AppliedProfile>;
};

export const getWorkflowAppliedProfilesRequest = async (
    workflowID: string
): Promise<GenericNetworkResponse<GetWorkflowAppliedProfileRequestResponse>> => {
    const appliedProfileType: Array<AppliedProfileTypes> = [
        AppliedProfileTypes.WORKFLOW
    ];

    const queryParamValue = getQueryParamValueArray(appliedProfileType);

    const queryParameters: Array<QueryParameter> = [{
        parameter: "type",
        value: queryParamValue
    },
    {
        parameter: "referrerID",
        value: workflowID
    }];

    const { data, error } = await handleRequestWithQueryParams(RequestTypes.GET, apiRoutes.serviceConfiguration.data.appliedProfileWithWorkflowId, queryParameters);
    return { data, error, queryParameters };

};